<template>
	<section>
		<div class="main_wrap">

			<!--Content Begin-->
			<div class="content">

				<root-header></root-header>

				<router-view></router-view>

			</div>
			<!--Content End-->

			<root-footer></root-footer>

		</div>

		<client-modal></client-modal>
		<staff-modal></staff-modal>
		<details-modal></details-modal>
		<edit-modal></edit-modal>
		<inquiry-modal></inquiry-modal>

		<time-modal></time-modal>
		<date-picker-modal></date-picker-modal>
		<range-picker-modal></range-picker-modal>
		<status-modal></status-modal>

	</section>
</template>

<script>
	import RootHeader from '../components/header/index.vue'
	import RootFooter from '../components/Footer.vue'

	import TimeModal from '@/components/TimeModal.vue'
	import DatePickerModal from '@/components/DatePickerModal.vue'
	import RangePickerModal from '@/components/RangePickerModal.vue'

	export default {
		name: "Free",
		components: {RootHeader, RootFooter, TimeModal, DatePickerModal, RangePickerModal},
		mounted() {
			this.$store.dispatch('specialization/all').then(result => {
				this.specializations = result.map(item => {
					item.id = item._id
					item.text = item.name

					return item
				})
			})

			this.$store.dispatch('clinicType/all').then(list => {
				this.clinicTypes = list.map(type => {
					type.id = type._id
					type.text = type.name

					return type
				})
			})
		},
		data() {
			return {
				specializations: [],
				clinicTypes: []
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Root.vue?43f5af84